<template>
    <div>
      <button class="goToTop arrow-up" @click="topFunction()" id="myBtn" :class="[computedClass, brandClass()]">
      </button>
    </div>
</template>

<script>

export default {
  name: 'ScrollToTop',
  inject:['brandClass',],
  data: () => ({
      computedClass: 'hide',
  }),
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll () {
        if (window.scrollY > 100) {
            this.computedClass = '';
        } else {
            this.computedClass = 'hide';
        }
    },
    topFunction() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
  }
}
</script>

<style lang="scss" scoped>



.goToTop {
  opacity: 1;
  position: fixed;
  bottom: 90px;
  right: 7%;
  border-width: 0px;
  transition: width 1s, height 1s;
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-color: $grey4;
  background-position: center ;
  transition: opacity 0.5s ease-in-out;
  z-index: 10;
  cursor: pointer;
  &.arrow-up{
    background-image: url('~@/assets/default/light/scroll-to-top-default-light.svg');
  }
  &.__d {
    background-image: url('~@/assets/default/dark/scroll-to-top-default-dark.svg');
    background-color: white !important;
  }
  &.hide {
    opacity: 0;
  }
  &.__m {
    background-color: #000;
  }
  &.__t {
    background-color: $toyotared;
  }
  &.__alphera {
    background-color: $grey4;
  }
  &.__alphabet {
    background-color: $alphabetblue;
  }
  &.__b {
    background-color: $grey4;
  }
  &:hover{
    outline: auto;
  }

}


//  toyota toyotared tutti senza bordi

</style>